import { BasePeoplePicker } from "office-ui-fabric-react";

export enum Table {
    User = 'User',
    UserCourse = 'UserCourse',
    Organiser = 'Organiser',
    Trainer = 'Trainer',
    Concentration = 'Concentration',
    Order = 'Order',
    Marketing = 'Marketing'
}

export interface IUser  {
    id: string
    table: string // "User"
    emailAdd: string
    userStatus: string
    userStatusDetails: string
    personId: string
    gender: string
    fullName: string
    icNo: string
    icFileName: string
    contactNo: string
    permanentAdd: string
    mailingAdd: string
    compName: string
    compReg: string
    compPosition: string
    compContactNo: string
    compAdd: string
    compSalaryRange: string
    country: string
    professionList: IPC[]
    cart: ICart
    createdDT: string
    createdBy: string
    lastEdited: string
    lastEditedBy: string
    logged: boolean
    verified: boolean
    version : number
    searchKeywords : string
    lastLogin : string
    userRoles : string[]
    faceImageList : string[]    // List of face images
    faceImageLastUpdated : string
}

export interface ICart {
    items: ICartItem [],
    subTot: number,
    tax : number,
    totAmt : number,
    billingInfo : ICartBillingInfo,
    pmtInfo : ICartPaymentInfo
 }

 export interface ICartItem{
    id: number,
    courseId: string,
    title:string,
    refNo:string,
    cpdPoints: ICPDPoints[],
    shortDesc: string,
    organisersName: string,
    courseImg: string,
    price : number
 }

 export interface ICartBillingInfo{
     name: string,
     address: string,
     phoneNo : string,
     email: string
 }
 
 export interface ICartPaymentInfo{
    pmtMethod: string,   // Bank / CreditCard / Etc
    pmtStatus: string    // Pending, InProgress, Paid
}

export interface IPC {
    [key: string]: any;
 }

 export interface ICourse {
    id: string                      // Unique identifier (Backend)
    courseId : string               // Course ID internal use
    referenceNumber: string         // Course Internal Reference Number (Modifiable by admin, e.g. Certification serial number using this, admin can change every year / or define a format for it)
    type:string                     // "Course"
    version: number                 // Schema version number
    professionList: string[]        // Profession list
    countryList: string[]           // Course country lits
    languages: string[]             // Course languages
    subtitle: string[]              // Course subtitle
    period:number                   // Partition key, year of course
    courseStatus : string           // Course Status, temporary not in use, based on expiry date
    title: string                   // Course Title
    titleLowercase : string         // Title lowercase for sorting purpose
    shortDesc : string              // Short description
    longDesc : string               // Long description
    objective : string              // Course objective
    programOutline : IProgramOutline[]       // Course outline
    courseFeatures : string[]         // Course Features
    qualification : string          // Qualificaiton
    requirement : string            // Requirements
    termsAndConditions : string     // Terms and conditons
    agenda : string                 // Course Agenda
    methodology : string            // Course Methodology
    publishedDT : Date              // Publish Date
    expiryDT : Date                 // Expiry Date
    videoURL : string               // Video URL (MP4)
    videoThumbnailURL : string      // Video Image URL (Thumbnail)
    courseFlyerURL : string         // Course Flyer URL
    courseCPDPointURL : string         // Course Flyer URL
    uploadDT : Date                 // Upload Date Time
    cpdPoints : ICPDPoints[]         // Array of CPDPoints
    duration : number               // Course duration
    currency : string               // Course Currency
    normalPrice : number            // Course Normal Price
    memberPrice: number             // Course Member Price
    discountCode : string[]
    discountPrice :number           // Course Discounted Price
    priceAdjNoVerification :number           // Course Discounted Price
    slidesFileURL : string          // Slides File URL
    courseShelfLifeDays : number    // Life time course display on market place
    userShelfLifeDays : number      // Life time user can playback
    organiser : IOrganiserProfile    // Organizer Profile
    trainerFAQFileURL : string      // Trainer FAQ
    trainerProfile : ITrainerProfile [] // Trainer Profile
    certificateId : string          // Certificate Template ID to use
    concentrationId : string        // Concentration Template ID to use
    concentrationDurationSettingsJSON : IConcentration[] // Concentration settings
    createdDT : Date                // Course created on
    createdBy : string              // Course created by
    lastEdited : Date               // Course last edited time
    lastEditBy : string             // Course last edited by who
    searchKeywords : string         // List of keywords for search
    verification : boolean
    noVerification : boolean
    noTracking : boolean
}

export interface IProgramOutline {
    duration : string         
    program : string
}
export interface ICPDPoints {
    profession : string         // Profession Name
    points : number             // CPD Hour/Points
    cpdRefNo : string           // CPD Reference Number
    cpdDesc : string,
    cpdIssuerName : string,
    cpdVerification : boolean,
    cpdExpiry : string
}
export interface IOrganiserProfile {
    id : string         
    oId : string             
    orgName : string
    orgProfile : string
    orgProfileImgURL : string
    orgEmail: string
    orgPhoneNo: string
    orgAddress : string
    orgProfession : string []
    contactPersonName : string        
    contactPersonTitle : string       
    contactPersonPhone : string      
    contactPersonWorkPhone : string      
    contactPersonEmail : string      
    trainers :  ITrainerProfile []
    searchKeywords : string
}

export interface IMarketing {
    id : string   
    promoCode : string
    description : string
    startDate : Date 
    endDate : Date 
    discType : string
    discAmount : number
    discPct: number
    
    ruleAmtFrom : number
    ruleAmtTo : number
    ruleLimitCourse : string []
    ruleLimitProfession : string []
    ruleLimitOrganizer : string []
    ruleLimitCountry : string []

    ruleLimitUse : number
    
    singleUserPerUser : boolean
    searchKeywords : string

    userLogs : string []
}
export interface ITrainerProfile {
    id : string
    organiserId : string
    name : string
    profile : string
    profileImgURL : string
    profession : string []
    searchKeywords : string
    // Job Title & Qualification
}
export interface IConcentration {
    id : number,
    duration : number[]
    AnswerSpot : number
}

 
export interface ICourseByCategoryDataModal {
    Category:string
    Ids:number[]
}


export interface IUserCourse  {
    id: string                  // Unique Id    
    table : string               // "UserCourse"
    oId : string                 // user Oid
    version: number             // Schema version
    orderId : string            // Order ID
    orderDT : Date            // Order DateTime
    videoURL : string           // Course Video URL
    videoThumbnailURL : string  // Course Video Thumbnail
    courseId : string           // Course ID
    courseTitle : string        // Course Title
    courseDuration : number     // Course Duration
    courseYear : number         // Course Year for filtering
    organiser : IOrganiserProfile    // Organizer Profile
    cpdPoints : ICPDPoints[]     // Array of CPDPoints
    refNo: string               // Course Internal Reference Number

    playUntilSeconds : number   // Course last play time
    concentrationDurationSettingsJSON : IConcentrationSetting[]  // Setting for concentration Question, copy from Course

    shelfLifeDays : number      // Days course in shelf
    expiryDT : Date           // Set when save course, use to query course yet to expired to show for user dashboard homepage
    startWatchDT? : Date       // For statistic purpose
    lastWatchDT? : Date         // Last Watch DateTime (When answered correct concentration Question
    completeWatchDT?: Date     // For cert generation
    facePhotoURLList : string[]  // To decide
    userQuestion : IUserQ []     // Question send by user using Ask Trainer feature
    feedback : IFeedbackQ[]      // Feedback by usre
    feedbackSubmitted : boolean // Flag set when feedback Submmiteed
    certIsGenerated : boolean   // Flag set when certificate generated
    certSerialNumber : string   // Certificate Serial Number
    certGeneratedOn? : Date    // Certificate generation datetime
    certFileName : string       // Certificate Serial Number
    faceImageList : string[]    // List of face images attended course
    createdDT : Date
    createdBy : string
    lastEdited : Date
    lastEditedBy : string

    redeemCode : string         // For Redemption

    searchKeywords : string     // For filtering purpose
    
}
export interface IConcentrationSettings{
    checkPoint:any
    skipDuration:number
}

export interface IFeedbackQ{
    id : number         // QuestionNumber 
    answer : string     // Answer
}
export interface IUserQ{
    sendDt : string     // Datetime ask trainer
    body : string       // Question to ask Trainer
}

export interface IConcentrationSetting{
    id : string 
    duration : number[]  // Random duration to show question
    AnswerSpot : number  // Time to show answer
}



export interface IConcentrationPicture {
    id : string,
    table : string, // Concentration
    version : number
    name : string
    categories : IConcentrationPictureCategory []
}

export interface IConcentrationPictureCategory {
    id: number,
    name : string,
    pictures : string []
}

export interface IOrder {
    id:string,
    date: Date,
    orderNo: string,
    userName : string,
    userId : string,
    noOfCourses: number,
    totAmt: number,
    cartItems: ICartItem [] 
}